module.exports = __webpack_public_path__ + "static/img/4.3642fb6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/sp/4.png
// module id = e6uZ
// module chunks = 0